import OfferTargetSelect from './OfferTargetSelect';

export default OfferTargetSelect;
